import classes from './SectionSubtitle.module.css';

const SectionTitle = (props)=>{
    return (
        <div className={classes.Title}>
            <small>{props.subtitle}</small>
            <h3>{props.title}</h3>
        </div>
    );
}

export default SectionTitle;